export const ACCOUNT_ENDED_STORAGE_KEY = 'mentiss.accountEnded.v1'
export const ACCOUNT_SESSION_REVALIDATE_EVENT
  = 'mentiss:account-session-revalidate'
const ACCOUNT_SESSION_REVALIDATE_TIMEOUT_MS = 8_000

export interface AccountSessionRevalidationDetail {
  complete?: (sessionIsValid: boolean) => void
}

export function signalAccountSessionRevalidation(): void {
  window.dispatchEvent(
    new CustomEvent<AccountSessionRevalidationDetail>(
      ACCOUNT_SESSION_REVALIDATE_EVENT,
    ),
  )
}

export function requestAccountSessionRevalidation(): Promise<boolean> {
  return new Promise((resolve) => {
    let settled = false
    const complete = (sessionIsValid: boolean) => {
      if (settled)
        return
      settled = true
      window.clearTimeout(timeout)
      resolve(sessionIsValid)
    }
    const timeout = window.setTimeout(
      () => complete(false),
      ACCOUNT_SESSION_REVALIDATE_TIMEOUT_MS,
    )
    window.dispatchEvent(
      new CustomEvent<AccountSessionRevalidationDetail>(
        ACCOUNT_SESSION_REVALIDATE_EVENT,
        { detail: { complete } },
      ),
    )
  })
}

export function publishAccountEnded(): void {
  signalAccountSessionRevalidation()
  try {
    const nonce
      = window.crypto.randomUUID?.() ?? `${Date.now()}-${Math.random()}`
    window.localStorage.setItem(ACCOUNT_ENDED_STORAGE_KEY, nonce)
  }
  catch {}
}
